import { objectSelector } from 'theme/utils';

const $P = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/signin`);

class SignInSmsVerficiationRejected {
  constructor(data) {
    const { smsCode } = data;

    this.smsCode = smsCode;
  }
}

export const signInSmsVerficiationRejectedMapper = (error) => {
  return new SignInSmsVerficiationRejected({
    smsCode: objectSelector(error, $P.ERROR_MESSAGES.SMS_CODE),
  });
};



// WEBPACK FOOTER //
// ./src/models/signInSmsVerificationRejected.js